import { TextField, TextFieldProps } from "@mui/material";
import { AnyFieldApi } from "@tanstack/react-form";
import { FC, forwardRef } from "react";

export interface SalifyFormTextFieldWrapperProps {
  field: AnyFieldApi;
  textFieldProps?: TextFieldProps;
}

const SalifyFormTextFieldWrapper = forwardRef<HTMLInputElement, SalifyFormTextFieldWrapperProps>(
  ({ field, textFieldProps }, ref) => {
    const {
      requiredMessage: _requiredMessage,
      validation: _validation,
      ...muiTextFieldProps
    } = (textFieldProps ?? {}) as TextFieldProps & {
      requiredMessage?: string;
      validation?: unknown;
    };

    return (
      <TextField
        variant="outlined"
        {...muiTextFieldProps}
        fullWidth={muiTextFieldProps?.fullWidth ?? true}
        id={field.name}
        name={field.name}
        value={field.state.value ?? ""}
        onBlur={field.handleBlur}
        onChange={
          muiTextFieldProps.onChange
            ? muiTextFieldProps.onChange
            : (e) => field.handleChange(e.target.value)
        }
        error={field.state.meta.errors.length > 0 || muiTextFieldProps?.error}
        helperText={
          field.state.meta.errors.length > 0 && field.state.meta.isTouched
            ? field.state.meta.errors.map((e) => e?.message).join(", ")
            : muiTextFieldProps?.helperText
        }
        inputRef={ref}
      />
    );
  },
);

SalifyFormTextFieldWrapper.displayName = "SalifyFormTextFieldWrapper";

export default SalifyFormTextFieldWrapper;
